// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__Xi4wM","btnOffer":"AddProduct_btnOffer__iZKWZ"};